import React from "react";

function WhyTezosPowers() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Tezos Powers a User-Centric Web3</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Tezos Blockchain Development for the Web3 Revolution The
                  future of the internet is here with Tezos a truly
                  decentralized and user-driven network. Tezos allows users to
                  exchange value and interact directly on a secure,
                  intermediary-free platform, embodying the core values of a
                  user-governed Web3 internet.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyTezosPowers;
